"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FaucetTokenFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_initialAmount",
                type: "uint256",
            },
            {
                internalType: "string",
                name: "_tokenName",
                type: "string",
            },
            {
                internalType: "uint8",
                name: "_decimalUnits",
                type: "uint8",
            },
            {
                internalType: "string",
                name: "_tokenSymbol",
                type: "string",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_owner",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "allocateTo",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "dst",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "src",
                type: "address",
            },
            {
                internalType: "address",
                name: "dst",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
class FaucetTokenFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(_initialAmount, _tokenName, _decimalUnits, _tokenSymbol, overrides) {
        return super.deploy(_initialAmount, _tokenName, _decimalUnits, _tokenSymbol, overrides || {});
    }
    getDeployTransaction(_initialAmount, _tokenName, _decimalUnits, _tokenSymbol, overrides) {
        return super.getDeployTransaction(_initialAmount, _tokenName, _decimalUnits, _tokenSymbol, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.FaucetTokenFactory = FaucetTokenFactory;
FaucetTokenFactory.bytecode = _bytecode;
FaucetTokenFactory.abi = _abi;
//# sourceMappingURL=FaucetTokenFactory.js.map